export enum Partners {
  ENROLY_AT = 'EnrolyAT',
  ENROLY_CT = 'EnrolyCT',
  ENROLY_BC = 'EnrolyBC',
  ENROLY_IA = 'EnrolyIA',
  ENROLY_VT = 'EnrolyVT',
}
